import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Get the session from the URL hash
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('OAuth callback error:', error);
          setError(error.message);
          // Redirect to login after 3 seconds
          setTimeout(() => navigate('/login'), 3000);
          return;
        }

        if (data.session) {
          console.log('OAuth session established:', data.session.user.email);
          
          // Check if user has a role in metadata
          const userRole = data.session.user.user_metadata?.role;
          
          // Store user data in localStorage for AuthContext
          const userData = {
            id: data.session.user.id,
            email: data.session.user.email,
            name: data.session.user.user_metadata?.full_name || data.session.user.email.split('@')[0],
            role: userRole || 'student', // Default to student if no role
            avatar: `https://ui-avatars.com/api/?name=${data.session.user.user_metadata?.full_name || data.session.user.email.split('@')[0]}&background=0891b2&color=fff`
          };
          
          localStorage.setItem('fourq_user', JSON.stringify(userData));
          
          // If no role is set (first time Google login), redirect to role selection
          if (!userRole) {
            setTimeout(() => {
              navigate('/select-role', { replace: true });
            }, 500);
          } else {
            // Has role, go to dashboard
            setTimeout(() => {
              navigate('/dashboard', { replace: true });
            }, 500);
          }
        } else {
          // No session found, redirect to login
          console.log('No session found, redirecting to login');
          setTimeout(() => navigate('/login'), 1000);
        }
      } catch (err) {
        console.error('Error handling OAuth callback:', err);
        setError(err.message);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    handleOAuthCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-cyan-600 via-blue-600 to-teal-600 flex items-center justify-center">
        <div className="text-white text-center max-w-md p-6">
          <div className="text-red-300 mb-4">
            <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold mb-2">Authentication Failed</h2>
          <p className="text-sm opacity-80">{error}</p>
          <p className="text-xs mt-4">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-600 via-blue-600 to-teal-600 flex items-center justify-center">
      <div className="text-white text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold">Completing authentication...</h2>
        <p className="text-sm mt-2 opacity-80">Please wait while we log you in</p>
      </div>
    </div>
  );
};

export default AuthCallback;
